import { isMobile } from '../helpers/isMobile';

export const AnimationConfigs = {
  intro: 'back.in(1.5)',
  loop: 'linear',
  forceStop: 'back.out(2)',
  stopNormal: 'customStopNormal',
  stopFast: 'customStopFast',
  stopTurbo: 'customStopTurbo',
  START_SPEED: -3,
  STOPPING_STEPS: 5,
  REVERSE_STEPS_FAST_MODE: 10,
  REVERSE_STEPS_STANDARD_MODE: isMobile() ? 7 : 10,
};
export const gameGlobalStates = {
  none: 'none',
  show: 'show',
  waiting: 'waiting',
  bonus: 'bonus',
};

export const reelsParams = [
  {
    visibleRows: 3,
    iconsInReel: 9,
    iconsHeight: isMobile() ? 100 : 170,
    iconsWidth: isMobile() ? 100 : 170,
    finalPositionX: 0,
    finalPositionY: 0,
    iconsSpacing: 0.5,
    spacing: isMobile() ? 6 : 10,
    iconMargins: { default: 98 },
    offsetForContainerBoardWidth: isMobile() ? 0 : 0,
    offsetForContainerBoardHeight: isMobile() ? 0 : 0,
    speedDuration: 0.35,
    iconsFinalPositions: {
      inWinContainer: [],
      inReel: [],
    },
  },
  {
    visibleRows: 3,
    iconsInReel: 9,
    iconsHeight: isMobile() ? 100 : 170,
    iconsWidth: isMobile() ? 100 : 170,
    finalPositionX: 0,
    finalPositionY: 0,
    iconsSpacing: 0.5,
    spacing: isMobile() ? 6 : 10,
    iconMargins: { default: 98 },
    offsetForContainerBoardWidth: isMobile() ? 0 : 0,
    offsetForContainerBoardHeight: isMobile() ? 0 : 0,
    speedDuration: 0.35,
    iconsFinalPositions: {
      inWinContainer: [],
      inReel: [],
    },
  },
  {
    visibleRows: 3,
    iconsInReel: 9,
    iconsHeight: isMobile() ? 100 : 170,
    iconsWidth: isMobile() ? 100 : 170,
    finalPositionX: 0,
    finalPositionY: 0,
    iconsSpacing: 0.5,
    spacing: isMobile() ? 6 : 10,
    iconMargins: { default: 98 },
    offsetForContainerBoardWidth: isMobile() ? 0 : 0,
    offsetForContainerBoardHeight: isMobile() ? 0 : 0,
    speedDuration: 0.35,
    iconsFinalPositions: {
      inWinContainer: [],
      inReel: [],
    },
  },
  {
    visibleRows: 3,
    iconsInReel: 9,
    iconsHeight: isMobile() ? 100 : 170,
    iconsWidth: isMobile() ? 100 : 170,
    finalPositionX: 0,
    finalPositionY: 0,
    iconsSpacing: 0.5,
    spacing: isMobile() ? 6 : 10,
    iconMargins: { default: 98 },
    offsetForContainerBoardWidth: isMobile() ? 0 : 0,
    offsetForContainerBoardHeight: isMobile() ? 0 : 0,
    speedDuration: 0.35,
    iconsFinalPositions: {
      inWinContainer: [],
      inReel: [],
    },
  },
  {
    visibleRows: 3,
    iconsInReel: 9,
    iconsHeight: isMobile() ? 100 : 170,
    iconsWidth: isMobile() ? 100 : 170,
    finalPositionX: 0,
    finalPositionY: 0,
    iconsSpacing: 0.5,
    spacing: isMobile() ? 6 : 10,
    iconMargins: { default: 98 },
    offsetForContainerBoardWidth: isMobile() ? 0 : 0,
    offsetForContainerBoardHeight: isMobile() ? 0 : 0,
    speedDuration: 0.35,
    iconsFinalPositions: {
      inWinContainer: [],
      inReel: [],
    },
  },
];
